module.exports = __webpack_public_path__ + "img/关黄柏.a3c29742.jpg";